// vcs-form.js — pure PATCH-body builder for the Settings page's Version Control tab
// (C1214/C1344). Client twin of api/src/lib/vcs-settings.js's buildVcsPatch(): that
// module VALIDATES a PATCH body server-side, this one BUILDS one client-side. Field
// names/order must stay in lockstep with that module's VCS_GIT_FLAGS.
//
// vcs_type is NULL by default (VCS integration off). The three suboption flags are
// git-only (svn has none) and are dormant, not force-reset, when vcs_type moves away
// from 'git' — the API accepts a `false` flag unconditionally but rejects a `true` flag
// when the effective vcs_type isn't 'git'. Sending explicit `false` on a Disabled/SVN
// save would zero out stored choices the user may switch back to, so buildVcsPatchBody()
// omits the three fields entirely unless vcsType === 'git'.

// `field` matches the DB column / PATCH body key 1:1 (see tt-api-projects.md § Version
// Control Settings, C1213). Adding a suboption is a one-line change here plus a
// matching migration/API change — see settings.js's renderVersionControlTab() for the
// render loop that consumes this array.
export const VCS_GIT_FLAGS = [
  { field: 'vcs_worktree_enabled', label: 'Git worktrees', hint: 'Run each task in its own worktree' },
  { field: 'vcs_commit_enabled', label: 'Commits', hint: 'Let agents commit their changes' },
  { field: 'vcs_pr_enabled', label: 'Pull requests', hint: 'Open a PR / merge request when done' },
];

// vcsType: '' | 'git' | 'svn' (radio value, '' -> Disabled). flags: { [field]: boolean }
// keyed by VCS_GIT_FLAGS' field names — a missing key coerces to false, an unknown key
// is ignored (only VCS_GIT_FLAGS' own fields are ever read).
export function buildVcsPatchBody(vcsType, flags) {
  const body = { vcs_type: vcsType || null };
  if (vcsType === 'git') {
    VCS_GIT_FLAGS.forEach(f => {
      body[f.field] = !!(flags && flags[f.field]);
    });
  }
  return body;
}
